<template>
  <div id="app">
    <router-view />
    <vue-snotify />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CloudProcessing extends Vue {
  private created() {
    this.$root.$on("ApolloNetworkError", (error: Error) => {
      if (error.message) {
        //this.$snotify.error(error.message, "Network error");
      }
    });
  }
}
</script>

<style lang="scss">
@import "scss/base";
</style>
